import React, { useState } from "react";
import {
  addConversationTag,
  removeConversationTag,
} from "../../services/conversationTagsApi";
import "./ConversationTags.css";

const ConversationTags = ({
  conversationId,
  tags = [],
  onAddTag,
  onRemoveTag,
}) => {
  const [tagText, setTagText] = useState("");
  const [status, setStatus] = useState("idle");
  const [errorMessage, setErrorMessage] = useState("");

  const handleAddTag = async () => {
    const tag = tagText.trim();

    // Validation
    if (!tag) {
      setStatus("error");
      setErrorMessage("Please enter a tag.");
      return;
    }

    if (!conversationId) {
      setStatus("error");
      setErrorMessage("Please select a conversation.");
      return;
    }

    // Duplicate validation
    if (
      tags.some(
        (existingTag) =>
          (existingTag.name || existingTag).toLowerCase() === tag.toLowerCase()
      )
    ) {
      setStatus("error");
      setErrorMessage("This tag already exists.");
      return;
    }

    setStatus("loading");
    setErrorMessage("");

    try {
      const response = await addConversationTag(
        conversationId,
        tag
      );

      if (response.success) {
        onAddTag(response.data);

        setTagText("");
        setStatus("success");

        setTimeout(() => {
          setStatus("idle");
        }, 1500);
      }
    } catch (error) {
      setStatus("error");
      setErrorMessage(
        "Failed to add tag. Please try again."
      );
    }
  };

  const handleRemoveTag = async (tagId) => {
    setStatus("loading");
    setErrorMessage("");

    try {
      const response = await removeConversationTag(
        conversationId,
        tagId
      );

      if (response.success) {
        onRemoveTag(tagId);

        setStatus("success");

        setTimeout(() => {
          setStatus("idle");
        }, 1000);
      }
    } catch (error) {
      setStatus("error");
      setErrorMessage(
        "Failed to remove tag. Please try again."
      );
    }
  };

  return (
    <div className="conversation-tags">

      {/* Header */}
      <div className="conversation-tags-header">
        <h3>Conversation Tags</h3>
        <span>Internal</span>
      </div>

      {/* Loading */}
      {status === "loading" && (
        <div className="tags-message">
          Updating tags...
        </div>
      )}

      {/* Success */}
      {status === "success" && (
        <div className="tags-success">
          Tag updated successfully!
        </div>
      )}

      {/* Empty State */}
      {status !== "loading" && tags.length === 0 && (
        <div className="tags-empty">
          No conversation tags yet.
        </div>
      )}

      {/* Tags */}
      {status !== "loading" && tags.length > 0 && (
        <div className="tags-list">
          {tags.map((tag) => (
            <div className="tag-item" key={tag.id}>
              <span>{tag.name}</span>

              <button
                type="button"
                onClick={() => handleRemoveTag(tag.id)}
                disabled={status === "loading"}
              >
                ×
              </button>
            </div>
          ))}
        </div>
      )}

      {/* Add Tag */}
      <div className="tags-form">
        <input
          type="text"
          value={tagText}
          onChange={(e) => {
            setTagText(e.target.value);
            setStatus("idle");
            setErrorMessage("");
          }}
          placeholder="Add a conversation tag..."
          disabled={status === "loading"}
        />

        <button
          type="button"
          onClick={handleAddTag}
          disabled={status === "loading"}
        >
          {status === "loading"
            ? "Saving..."
            : "Add Tag"}
        </button>
      </div>

      {/* Error */}
      {status === "error" && (
        <div className="tags-error">
          {errorMessage}
        </div>
      )}

    </div>
  );
};

export default ConversationTags;